import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import TreatmentPlanForm from "./TreatmentPlanForm";
import { fetchTreatmentPlan, updateTreatmentPlan } from "../../../store/slices/treatmentPlanSlice";

const EditTreatmentPlan = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        patientId: "",
        caseId: "",
        treatmentOption: "",
        reason: ""
    });

    // Fetch treatment plan by ID
    useEffect(() => {
        const getTreatmentPlan = async () => {
            try {
                const response = await dispatch(fetchTreatmentPlan(id)).unwrap();
                // Map backend snake_case keys to camelCase for frontend state
                setFormData({
                    patientId: response.patient_id,
                    caseId: response.case_id,
                    treatmentOption: response.treatment_option,
                    reason: response.reason,
                });
            } catch (err) {
                Swal.fire("Error!", err || "Failed to fetch Treatment Plan", "error");
            }
        };

        getTreatmentPlan();
    }, [dispatch, id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Map frontend camelCase state to backend snake_case keys
        const payload = {
            patient_id: formData.patientId,
            case_id: formData.caseId,
            treatment_option: formData.treatmentOption,
            reason: formData.reason,
        };

        try {
            await dispatch(updateTreatmentPlan({ id, data: payload })).unwrap();
            Swal.fire("Updated!", "Treatment Plan form updated successfully.", "success");
            navigate("/home-visit/treatment-plan");
        } catch (err) {
            Swal.fire("Error!", err || "Failed to update Treatment Plan", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <TreatmentPlanForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button
                                        type="submit"
                                        className="btn btn-primary px-4"
                                    >
                                        <i className="ri-edit-2-line me-1"></i>
                                        Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditTreatmentPlan;
